import React from "react";
import { Button, ClearUserProfile } from "@dev-apps/common-ui-components";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import axios from "axios";
import {useContext} from "react";

export default function Login(userProfile) {
  const clearUserProfile = useContext(ClearUserProfile);

  async function logout()
  {
    const securityEndpoint = "/api/security"
    await axios.get(`${securityEndpoint}/csrf`, { withCredentials: true });
    await axios.post(`${securityEndpoint}/logout`, {}, { withCredentials: true } );

    clearUserProfile();

    window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/sewppublic/login`;
  }


  if (userProfile) {
    return <div className="pl-4 flex items-center cursor-pointer text-sm xl:text-base font-bold whitespace-nowrap">
      <Button variant="outlined" color="inherit" className="bg-white text-sewp-purple hover:underline" onClick={logout}>
        <AccountCircleIcon className="mr-1" />
        Logout
      </Button>
    </div>;
  } else {
    return (<a href={`${process.env.NEXT_PUBLIC_BASE_URL}/sewppublic/login`}
      className="pl-4 flex items-center cursor-pointer text-sm xl:text-base font-bold whitespace-nowrap">
      <Button variant="outlined" color="inherit" className="bg-white text-sewp-purple hover:underline">
        <AccountCircleIcon className="mr-1" />
        Login
      </Button>
    </a>);
  }
}
